export default "__VITE_ASSET__CJH02Rdy__"